import {
  ClientForm,
  ClientList,
  Clients,
  useClientDetails,
  useClientList,
  createClient,
  updateClient,
  updateClientInCharge,
  deleteClient,
  getImageFileUrl,
  useClientTypeList,
  ClientType,
  useEmployeeList,
  ClientContactForm,
  updateClientContact,
  useProjectDetailsByClient,
  ClientInChargeForm,
  EmployeeDetailsForClient,
} from "./api";
import { useState, useEffect, useRef } from "react";
import DataLoading from "../../components/DataLoading";
import * as Yup from "yup";
import { Dialog } from "primereact/dialog";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import Button from "react-bootstrap/esm/Button";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { Employees } from "../Team/api";
import defaultpicture from "../../assets/images/image-defaultpicture.png";
import projectEmptyIcon from "../../assets/images/project-empty-icon.png";
import clientProjectCardImage from "../../assets/images/client-project-card-image-normal.png";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";
import { hasPermission } from "../../helpers/common";
import { getPermissionsList } from "../../helpers/getPermission";
import DefaultImage from "../../profile_images/DefaultImage";

type ClientsItemProps = Clients & {
  selectedClientName: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectedClient: React.Dispatch<React.SetStateAction<string | undefined>>;
  clientId: string | undefined;
  setSelectClientDetails: React.Dispatch<
    React.SetStateAction<ClientList | undefined>
  >;
};

const ClientSidePanel = ({
  clientsList,
  isLoading,
  setSelectedClient,
  selectedClientName,
  clientId,
  setshowClientModal,
  setSelectClientDetails,
  setIsClientUpdate,
  setClientFields,
  clientMutate,
  permissions,
}: {
  clientsList: Clients[] | undefined;
  isLoading: boolean;
  setSelectedClient: React.Dispatch<React.SetStateAction<string | undefined>>;
  selectedClientName: React.Dispatch<React.SetStateAction<string | undefined>>;
  clientId: string | undefined;
  setshowClientModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectClientDetails: React.Dispatch<
    React.SetStateAction<ClientList | undefined>
  >;
  setIsClientUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  setClientFields: React.Dispatch<React.SetStateAction<ClientForm>>;
  clientMutate: any;
  permissions: any;
}) => {
  const [toggleNav, setToggleNav] = useState("open");
  const openNav = () =>
    setToggleNav((state) => (state === "open" ? "close" : "open"));

  if (isLoading) {
    return <DataLoading />;
  }

  // Sort clientsList alphabetically by client_name
  const sortedClientsList = clientsList
    ?.slice()
    .sort((a, b) => a.client_name.localeCompare(b.client_name));

  return (
    <div className="collapse-box-wrap">
      <div className={`collapse-box team-theme ${toggleNav}`}>
        <div className="d-flex col-head pb-0">
          <div className="d-flex title-action">
            <p>Clients List</p>
            {hasPermission(permissions, ["clients:write"]) && (
              <button
                className="d-flex icon-button"
                type="button"
                data-bs-toggle="modal"
                onClick={() =>
                  openCreateClient(
                    setshowClientModal,
                    setIsClientUpdate,
                    setClientFields
                  )
                }
              >
                <span className="material-icons-round">add</span>
              </button>
            )}
          </div>
          <button onClick={openNav}>
            <span className="material-icons-round">keyboard_arrow_left</span>
          </button>
        </div>
        <div className="col-body">
          <div className="col-bd-ele">
            {clientsList?.map((item) => (
              <ClientsItem
                key={item._id}
                _id={item._id}
                client_name={item.client_name}
                setSelectedClient={setSelectedClient}
                selectedClientName={selectedClientName}
                clientId={clientId}
                setSelectClientDetails={setSelectClientDetails}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const ClientsItem: React.FC<ClientsItemProps> = ({
  _id,
  client_name,
  setSelectedClient,
  selectedClientName,
  clientId,
  setSelectClientDetails,
}) => {
  const { clientsDetails } = useClientDetails(_id);

  const handleClick = (_id: string) => {
    setSelectedClient(_id);
    selectedClientName(client_name);
    if (clientsDetails) {
      setSelectClientDetails(clientsDetails);
      //clientMutate()
    }
    localStorage.setItem("preSelectedClient", _id);
  };

  return (
    <div
      className={`d-flex task-name ${_id === clientId ? "clicked" : ""} `}
      onClick={() => handleClick(_id)}
    >
      <div className="d-flex">
        <span className="material-icons-outlined">supervised_user_circle</span>
        <p>{client_name}</p>
      </div>
      <div className="arr-ryt">
        <span className="material-icons-round">keyboard_arrow_right</span>
      </div>
    </div>
  );
};

const openCreateClient = (
  setshowClientModal: React.Dispatch<React.SetStateAction<boolean>>,
  setIsClientUpdate: React.Dispatch<React.SetStateAction<boolean>>,
  setClientFields: React.Dispatch<React.SetStateAction<ClientForm>>
) => {
  setIsClientUpdate(false);
  let clientForm: ClientForm = {
    _id: "",
    client_name: "",
    profilepic: "",
    client_type: "",
    website: "",
    location: "",
    client_contact: [],
    client_incharge: [],
  };
  setClientFields(clientForm);
  setshowClientModal(true);
};

const ClientModal = ({
  myToast,
  isClientUpdate,
  showClientModal,
  handleClientClose,
  clientFields,
  refreshClientList,
  handleClientShow,
  setSelectedClientName,
  setSelectedClient,
  hiddenFileInput,
  setSelectedImage,
  setSelectedFilePath,
  selectImage,
  clientDetailsMutate,
  selectFilePath,
  clientTypeList,
}: {
  showClientModal: boolean;
  handleClientClose: () => void;
  isClientUpdate: boolean;
  clientFields: ClientForm;
  refreshClientList: any;
  myToast: any;
  setSelectedClientName: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  setSelectedClient: React.Dispatch<React.SetStateAction<string | undefined>>;
  hiddenFileInput: any;
  setSelectedImage: React.Dispatch<React.SetStateAction<string | undefined>>;
  setSelectedFilePath: React.Dispatch<React.SetStateAction<string | undefined>>;
  selectImage: string | undefined;
  selectFilePath: string | undefined;
  clientTypeList: ClientType[] | undefined;
  clientDetailsMutate: any;
  handleClientShow: () => void;
}) => {
  const [clientModalButtonDisabled, setIsClientModalButtonDisabled] =
    useState(false);
    const [hasShownWarning, setHasShownWarning] = useState(false);

  const clientFormValidation = Yup.object({
    client_name: Yup.string()
      .required("*")
      .matches(
        /^[a-zA-Z\s]+$/,
        "This field cannot contain numbers and special characters"
      ),
    profilepic: Yup.string(),
    client_type: Yup.mixed().notOneOf(["select"]).required("*"),
    website: Yup.string().matches(
      /^(https?:\/\/)?(www\.)[a-zA-Z0-9-]+\.[a-zA-Z]{2,6}(\S*)?$/,
      "Invalid URL format"
    ),
    location: Yup.string(),
  });

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const handleClientForm = async (values: ClientForm) => {
    const { _id, client_name, client_type, website, location } = values;
    let result;
    try {
      if (isClientUpdate && _id) {
        result = await updateClient(_id, {
          client_name,
          profilepic: selectFilePath ? selectFilePath : "",
          client_type,
          website,
          location,
        });
        if (result.status === 200) {
          showToast(
            "success",
            "Success Message",
            "Client was updated successfully."
          );
        }
        setSelectedClientName(client_name);
      } else {
        let result = await createClient({
          client_name,
          profilepic: selectFilePath ? selectFilePath : "",
          client_type,
          website,
          location,
        });
        if (result.statusCode === 201) {
          showToast(
            "success",
            "Success Message",
            "Client was created successfully."
          );
        }
      }
      refreshClientList();
      clientDetailsMutate();
      setSelectedImage(undefined);
      handleClientClose();
    } catch (error) {
      showToast("warn", "Warning", "Client name already exists");
      console.log(error);
    }
    setIsClientModalButtonDisabled(false);
  };
  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleChange = async (event: any) => {
    const fileUploaded = event.target.files[0];
    let formData = new FormData();
    formData.append("file", fileUploaded);
    formData.append("intent", "userprofile");
    const result = await getImageFileUrl(formData);
    setSelectedImage(result.url);
    setSelectedFilePath(result.fileKey);
  };

  const cancelAddClient = () => {
    setSelectedImage(undefined);
    handleClientClose();
  };

  const handleClientOnHide = () => {
    setSelectedImage(undefined);
    handleClientClose();
  };
  useEffect(() => {
    setSelectedImage(clientFields.profilepic);
  }, []);
  useEffect(() => {
    if (hasShownWarning) {
      showToast("warn", "Warning", "Kindly fill the required fields!");
    }
  }, [hasShownWarning]);
  return (
    <Dialog
      visible={showClientModal}
      onHide={handleClientOnHide}
      style={{ width: "50vw" }}
      header={!isClientUpdate ? "Add New Client" : "Edit Client Details"}
      className="details-edit-body dtls-update"
    >
      <Formik
        initialValues={clientFields}
        validationSchema={clientFormValidation}
        onSubmit={(values) => {
          setIsClientModalButtonDisabled(true);
          handleClientForm(values);
        }}
      >
        {({ errors, values, touched, isSubmitting, setFieldValue }) => {
          if (Object.keys(errors).length > 0 && isSubmitting) {
            setHasShownWarning(true);
          } else {
            setHasShownWarning(false);
          }
          return (
            <Form>
              <div className="modal-body-inner pt-0">
                <div className="team-user-image">
                  <div className="team-user-image-inner">
                    <button
                      className="d-flex add-time"
                      type="button"
                      onClick={() => handleClick()}
                    >
                      <span className="material-icons-outlined">
                        photo_camera
                      </span>
                    </button>
                    <img src={selectImage} alt="" />
                    <input
                      type="file"
                      ref={hiddenFileInput}
                      onChange={handleChange}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>

                {errors.client_name && touched.client_name ? (
                  <span style={{ color: "red" }}>{errors.client_name}</span>
                ) : null}
                <div className="form-group lg-input">
                  <Field
                    name="client_name"
                    placeholder="Enter Client Name "
                    disabled={isClientUpdate} // If client_name exists, disable the field
                  />
                </div>
                <div className="lst-tsk-nm mb-0">
                  <div className="dtls-update">
                    <div className="d-flex list-headings">
                      <p className="d-flex">
                        TYPE
                        {errors.client_type && touched.client_type ? (
                          <span style={{ color: "red" }}>*</span>
                        ) : null}
                      </p>
                      <div className="drpdwn-slct">
                        <Field name="client_type">
                          {({ field }: { field: any }) => (
                            <select {...field} name="client_type">
                              <option value="">Select</option>
                              {clientTypeList?.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          )}
                        </Field>
                        {errors.client_type && touched.client_type && (
                          <div style={{ color: "red" }}>
                            {errors.client_type}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex list-headings">
                      <p className="d-flex">WEBSITE </p>
                      <div className="drpdwn-slct">
                        <Field
                          name="website"
                          placeholder="Enter Site Url "
                        ></Field>
                      </div>
                      {errors.website && touched.website ? (
                        <span style={{ color: "red" }}>{errors.website}</span>
                      ) : null}
                    </div>

                    <div className="d-flex list-headings">
                      <p className="d-flex">LOCATION </p>
                      <div className="drpdwn-slct">
                        <Field
                          name="location"
                          placeholder="Enter Client Location "
                        ></Field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <div>
                  {isClientUpdate && values._id ? (
                    <Button
                      type="button"
                      className="btn delete delete-full-btn"
                      onClick={() =>
                        confirmDeleteClient(
                          values._id,
                          refreshClientList,
                          setSelectedClient,
                          handleClientClose,
                          myToast,
                          handleClientShow
                        )
                      }
                    >
                      Delete
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
                <div></div>
                <div className="d-flex">
                  <button
                    type="button"
                    className=" btn cancel"
                    data-bs-dismiss="modal"
                    onClick={cancelAddClient}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn save"
                    disabled={clientModalButtonDisabled || isSubmitting}
                  >
                    {!isClientUpdate ? "Add" : "Save"}
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const confirmDeleteClient = async (
  clientId: string | undefined,
  refreshClientList: any,
  setSelectedClient: React.Dispatch<React.SetStateAction<string | undefined>>,
  handleClientClose: () => void,
  myToast: any,
  handleClientShow: () => void
) => {
  confirmDialog({
    message: "Do you want to delete this record?",
    header: "Confirmation",
    className: "mini-alert-popup-ui",
    icon: "pi pi-exclamation-circle",
    accept: () =>
      deleteClientItem(
        clientId,
        refreshClientList,
        setSelectedClient,
        handleClientClose,
        myToast,
        handleClientShow
      ),
    reject: () => handleClientShow(),
  });

  const deleteClientItem = async (
    clientId: string | undefined,
    refreshClientList: any,
    setSelectedClient: React.Dispatch<React.SetStateAction<string | undefined>>,
    handleClientClose: () => void,
    myToast: any,
    handleClientShow: () => void
  ) => {
    const showToast = (
      severityValue: string,
      summaryValue: string,
      detailValue: string
    ) => {
      myToast.current.show({
        severity: severityValue,
        summary: summaryValue,
        detail: detailValue,
      });
    };
    if (clientId) {
      try {
        let result = await deleteClient(clientId);
        if (result.status === 200) {
          showToast(
            "success",
            "Success Message",
            "Client  deleted successfully."
          );
        }
      } catch (error) {
        showToast("warn", "Warning", "Client Exists Some Projects!");
        console.log(error);
      }
      refreshClientList();
      handleClientClose();
    }
  };
};

const setUpdateClientModal = ({
  setIsClientUpdate,
  setSelectedImage,
  setshowClientModal,
  clientDetails,
  setClientFields,
}: {
  setIsClientUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  setshowClientModal: React.Dispatch<React.SetStateAction<boolean>>;
  clientDetails: ClientList | undefined;
  setClientFields: React.Dispatch<React.SetStateAction<ClientForm>>;
  setSelectedImage: React.Dispatch<React.SetStateAction<string | undefined>>;
}) => {
  setIsClientUpdate(true);
  if (clientDetails) {
    let clientForm: ClientForm = {
      _id: clientDetails._id,
      client_name: clientDetails.client_name,
      profilepic: clientDetails.profilepic,
      client_type: clientDetails.client_type,
      website: clientDetails.website,
      location: clientDetails.location,
      client_contact: clientDetails.client_contact,
      client_incharge: clientDetails.client_incharge,
    };
    setClientFields(clientForm);
    setSelectedImage(clientDetails.profilepic);
  }
  setshowClientModal(true);
};

const ClientMainPage = ({
  showClientModal,
  handleClientClose,
  setSelectedImage,
  isClientUpdate,
  refreshClientList,
  setshowClientModal,
  setIsClientUpdate,
  setClientFields,
  clientDetails,
  employeesList,
  setSelectedClient,
  setClientContactFields,
  clientContactFields,
  setSelectedEmployee,
  selectedEmployee,
  projectDetailsByClient,
  setSelectedClientName,
  clientInChargeForm,
  myToast,
  refreshClientDetails,
  clientTypeList,
  permissions,
}: {
  showClientModal: boolean;
  handleClientClose: () => void;
  isClientUpdate: boolean;
  clientDetails: ClientList;
  setshowClientModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsClientUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  setClientFields: React.Dispatch<React.SetStateAction<ClientForm>>;
  setClientContactFields: React.Dispatch<
    React.SetStateAction<ClientContactForm>
  >;
  employeesList: Employees[];
  setSelectedClient: React.Dispatch<React.SetStateAction<string | undefined>>;
  clientContactFields: ClientContactForm;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  selectedEmployee: string;
  refreshClientDetails: any;
  projectDetailsByClient: ClientList | undefined;
  clientInChargeForm: ClientInChargeForm;
  setSelectedClientName: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  setSelectedImage: React.Dispatch<React.SetStateAction<string | undefined>>;
  myToast: any;
  clientTypeList: ClientType[] | undefined;
  refreshClientList: any;
  permissions: any;
}) => {
  return (
    <div className="task-top-table-separate">
      <div className="tsk-lists-wrap tsk-lists-wrap-client">
        <div className="tsk-lists">
          <ClientEditPanel
            clientDetails={clientDetails}
            setSelectedImage={setSelectedImage}
            setshowClientModal={setshowClientModal}
            setIsClientUpdate={setIsClientUpdate}
            setClientFields={setClientFields}
            clientTypeList={clientTypeList}
            permissions={permissions}
          />
          <div className="split-container">
            <div className="inr-split-two">
              <ClientInCharge
                clientDetails={clientDetails}
                refreshClientDetails={refreshClientDetails}
                employeesList={employeesList}
                myToast={myToast}
                selectedEmployee={selectedEmployee}
                clientInChargeForm={clientInChargeForm}
                setSelectedClientName={setSelectedClientName}
                isClientUpdate={isClientUpdate}
                setSelectedEmployee={setSelectedEmployee}
                permissions={permissions}
              />
              <ClientContact
                clientDetails={clientDetails}
                refreshClientDetails={refreshClientDetails}
                setSelectedClient={setSelectedClient}
                myToast={myToast}
                setClientContactFields={setClientContactFields}
                clientContactFields={clientContactFields}
                permissions={permissions}
              />
            </div>
            <ProjectList clientDetails={clientDetails} />
          </div>
        </div>
      </div>
    </div>
  );
};

const ClientInCharge = ({
  clientDetails,
  myToast,
  refreshClientDetails,
  employeesList,
  isClientUpdate,
  selectedEmployee,
  clientInChargeForm,
  setSelectedClientName,
  setSelectedEmployee,
  permissions,
}: {
  clientDetails: ClientList;
  isClientUpdate: boolean;
  employeesList: Employees[];
  myToast: any;
  refreshClientDetails: any;
  permissions: any;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  setSelectedClientName: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  selectedEmployee: string;
  clientInChargeForm: ClientInChargeForm;
}) => {
  const [showClientInChargeModel, setClientInChargeShow] = useState(false);
  const handleClientInChargeModelClose = () => setClientInChargeShow(false);

  const handleClickClientInCharge = () => {
    setClientInChargeShow(true);
  };
  const handleClickClientInChargeEdit = () => {
    setClientInChargeShow(true);
    if (
      clientDetails.client_incharge &&
      clientDetails.client_incharge.length > 0
    ) {
      clientInChargeForm.client_incharge = clientDetails.client_incharge;
    }
    setSelectedEmployee("");
  };

  return (
    <div className="card-ui card-head-body-group">
      {showClientInChargeModel &&
      hasPermission(permissions, ["clients:write"]) ? (
        <OpenClientInChargeModel
          showClientInChargeModel={showClientInChargeModel}
          handleClientInChargeModelClose={handleClientInChargeModelClose}
          myToast={myToast}
          employeesList={employeesList}
          refreshClientDetails={refreshClientDetails}
          clientDetails={clientDetails}
          setSelectedEmployee={setSelectedEmployee}
          selectedEmployee={selectedEmployee}
          clientInChargeForm={clientInChargeForm}
          isClientUpdate={isClientUpdate}
          setSelectedClientName={setSelectedClientName}
        />
      ) : (
        ""
      )}
      <div className="card-head">
        <h3>
          {" "}
          Client In Charge{" "}
          {clientDetails.client_incharge &&
          clientDetails.client_incharge.length > 0
            ? `(${clientDetails.client_incharge.length})`
            : ""}
        </h3>
        {clientDetails.client_incharge &&
        clientDetails.client_incharge.length > 0
          ? hasPermission(permissions, ["clients:write"]) && (
              <button
                className="d-flex outlined-button"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#client-incharge-popup"
                onClick={handleClickClientInChargeEdit}
              >
                <span className="material-icons-outlined">edit</span>
                <p>Edit</p>
              </button>
            )
          : ""}
      </div>

      {clientDetails.client_incharge &&
      clientDetails.client_incharge.length > 0 ? (
        clientDetails?.client_incharge.map((item: any, i: number) => (
          <div className="card-body" key={i}>
            <div className="card-image-action-t-r">
              <div className="card-image-block">
                {/* <img src={item.profilepic && item.profilepic!= '' ? item.profilepic : defaultpicture}                                className="img-fluid" /> */}
                <DefaultImage
                  src={item.profilepic}
                  alt=""
                  className="img-fluid"
                  letter={item.name[0]}
                />
              </div>
              <div className="card-inner-details-block">
                <h4> {item.name} </h4>
                <div className="icon-text-group">
                  <a href="javascript::">
                    {" "}
                    <span className="material-icons-outlined texted-icons">
                      email
                    </span>
                    {item.email_id}
                  </a>
                </div>
                <div className="icon-text-group">
                  <a href="javascript::">
                    <span className="material-icons-outlined texted-icons">
                      language
                    </span>
                    {item.phonenumber}
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="tsk-btn mt-4 mb-4">
          <button
            className={`d-flex btn bg-success text-white ${
              !hasPermission(permissions, ["clients:write"])
                ? "bg-opacity-25 bg-success"
                : ""
            }`}
            disabled={!hasPermission(permissions, ["clients:write"])}
            type="button"
            onClick={handleClickClientInCharge}
            data-bs-toggle="modal"
            data-bs-target="#client-incharge-popup"
          >
            <span className="material-icons-round">add</span>
            <p className=" text-white">Add</p>
          </button>
        </div>
      )}
    </div>
  );
};

const ClientContact = ({
  clientDetails,
  setSelectedClient,
  setClientContactFields,
  clientContactFields,
  myToast,
  refreshClientDetails,
  permissions,
}: {
  clientDetails: ClientList;
  setSelectedClient: React.Dispatch<React.SetStateAction<string | undefined>>;
  refreshClientDetails: any;
  setClientContactFields: React.Dispatch<
    React.SetStateAction<ClientContactForm>
  >;
  clientContactFields: ClientContactForm;
  myToast: any;
  permissions: any;
}) => {
  const [showClientContactModel, setClientContactShow] = useState(false);
  const handleClientContactModelClose = () => setClientContactShow(false);

  const handleClickClientContact = () => {
    setClientContactShow(true);
  };

  const handleClickClientContactEdit = () => {
    setClientContactShow(true);
    if (
      clientDetails.client_contact &&
      clientDetails.client_contact.length > 0
    ) {
      clientContactFields.client_contact = clientDetails.client_contact;
    }
  };

  return (
    <div className="card-ui card-head-body-group">
      {showClientContactModel &&
      hasPermission(permissions, ["clients:write"]) ? (
        <OpenClientContact
          showClientContactModel={showClientContactModel}
          myToast={myToast}
          handleClientContactModelClose={handleClientContactModelClose}
          setSelectedClient={setSelectedClient}
          clientDetails={clientDetails}
          refreshClientDetails={refreshClientDetails}
          setClientContactFields={setClientContactFields}
          clientContactFields={clientContactFields}
        />
      ) : (
        ""
      )}
      <div className="card-head">
        <h3>
          {" "}
          Client Contact{" "}
          {clientDetails.client_contact &&
          clientDetails.client_contact.length > 0
            ? `(${clientDetails.client_contact.length})`
            : ""}
        </h3>
        {clientDetails.client_contact &&
        clientDetails.client_contact.length > 0 &&
        hasPermission(permissions, ["clients:write"]) ? (
          <button
            className="d-flex outlined-button"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#client-contact-popup"
            onClick={handleClickClientContactEdit}
          >
            <span className="material-icons-outlined">edit</span>
            <p>Edit</p>
          </button>
        ) : (
          ""
        )}
      </div>
      {clientDetails.client_contact &&
      clientDetails.client_contact.length > 0 ? (
        clientDetails?.client_contact.map((item: any, i: number) => (
          <div className="card-body" key={i}>
            <div className="card-image-action-t-r">
              <div className="card-image-block">
                {/* <img src={defaultpicture} alt="lg-user-image" className="img-fluid" /> */}
                <DefaultImage
                  src={""}
                  alt="lg-user-image"
                  className="img-fluid"
                  letter={item?.mail_id?.[0] || item?.name?.[0] || ""}
                />
              </div>
              <div className="card-inner-details-block">
                <h4> {item.name} </h4>
                <h6> {item.role} </h6>
                <div className="icon-text-group">
                  <a href="javascript::">
                    {" "}
                    <span className="material-icons-outlined texted-icons">
                      email
                    </span>
                    {item.mail_id}
                  </a>
                </div>
                <div className="icon-text-group">
                  <a href="javascript::">
                    <span className="material-icons-outlined texted-icons">
                      language
                    </span>
                    {item.phone_number}
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="card-body">
          <div className="empty-add-ui">
            <button
              className="d-flex filled-button"
              type="button"
              onClick={handleClickClientContact}
              data-bs-toggle="modal"
              data-bs-target="#client-contact-popup"
            >
              <span className="material-icons-round">add</span>
              <p>Add</p>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const OpenClientContact = ({
  showClientContactModel,
  refreshClientDetails,
  handleClientContactModelClose,
  myToast,
  setSelectedClient,
  clientDetails,
  setClientContactFields,
  clientContactFields,
}: {
  showClientContactModel: boolean;
  handleClientContactModelClose: () => void;
  myToast: any;
  setSelectedClient: React.Dispatch<React.SetStateAction<string | undefined>>;
  setClientContactFields: React.Dispatch<
    React.SetStateAction<ClientContactForm>
  >;
  clientDetails: ClientList | undefined;
  clientContactFields: ClientContactForm;
  refreshClientDetails: any;
}) => {
  const [clientContactSaveBtnClicked, setIsClientContactSaveBtnClicked] =
    useState(false);
  const clientContactFormValidation = Yup.object().shape({
    client_contact: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .matches(/^[A-Za-z ]+$/g, "only letters is valid")
          .required("*"),
        role: Yup.string(),
        mail_id: Yup.string()
          .required("*")
          .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            "Enter a valid username"
          ),
        phone_number: Yup.string().matches(/^\d{10}$/, "Invalid"),
      })
    ),
  });

  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const handleClientContactForm = async (values: ClientContactForm) => {
    try {
      if (values && clientDetails?._id) {
        const resp = await updateClientContact(
          clientDetails._id,
          values.client_contact
        );
        if (resp.status === 200) {
          showToast(
            "success",
            "Success Message",
            "Client Contact Data was updated successfully."
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
    refreshClientDetails();
    handleClientContactModelClose();
    setIsClientContactSaveBtnClicked(false);
  };

  return (
    <Dialog
      visible={showClientContactModel}
      onHide={handleClientContactModelClose}
      style={{ width: "50vw" }}
      header={"Client Contacts"}
    >
      <Formik
        initialValues={clientContactFields}
        validationSchema={clientContactFormValidation}
        onSubmit={(values: any) => {
          setIsClientContactSaveBtnClicked(true);
          handleClientContactForm(values);
        }}
      >
        {({ values, touched, errors, isSubmitting }) => {
          return (
            <Form>
              <FieldArray name="client_contact">
                {({ push, remove }) => (
                  <div>
                    <div key={0}>
                      <div className="m-4 mt-0">
                        <button
                          className="d-flex filled-button"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#client-contact-popup"
                          onClick={() =>
                            push({
                              name: "",
                              role: "",
                              mail_id: "",
                              phone_number: "",
                            })
                          }
                        >
                          <span className="material-icons-round">add</span>
                          <p>Add</p>
                        </button>
                      </div>
                    </div>
                    <div className="modal-body">
                      {values?.client_contact?.length > 0 &&
                        values?.client_contact?.map(
                          (client_contact: any, index: any) => (
                            <div className="modal-body" key={index}>
                              <div
                                key={index}
                                className="card-image-active-inputs"
                              >
                                <div className="team-user-image-inner">
                                  <img src={defaultpicture} alt="" />
                                  <button
                                    className="d-flex outlined-button position-unset"
                                    type="button"
                                    onClick={() => remove(index)}
                                  >
                                    <span className="material-icons-outlined">
                                      delete
                                    </span>
                                  </button>
                                </div>
                                <div className="card-inner-details-block">
                                  <div className="lst-tsk-nm dtls-update">
                                    <div className="d-flex list-headings">
                                      <p className="d-flex">
                                        Name{" "}
                                        {errors.client_contact &&
                                        touched.client_contact ? (
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        ) : null}
                                      </p>
                                      <div className="drpdwn-slct">
                                        <Field
                                          name={`client_contact.${index}.name`}
                                          placeholder="Name"
                                        />
                                        <ErrorMessage
                                          name={`client_contact.${index}.name`}
                                          component="span"
                                        />
                                      </div>
                                    </div>
                                    <div className="d-flex list-headings">
                                      <p className="d-flex">Designation</p>
                                      <div className="drpdwn-slct">
                                        <Field
                                          name={`client_contact.${index}.role`}
                                          placeholder="Designation"
                                        />
                                        <ErrorMessage
                                          name={`client_contact.${index}.role`}
                                          component="span"
                                        />
                                      </div>
                                    </div>
                                    <div className="d-flex list-headings">
                                      <p className="d-flex">
                                        Email{" "}
                                        {errors.client_contact &&
                                        touched.client_contact ? (
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        ) : null}
                                      </p>
                                      <div className="drpdwn-slct">
                                        <Field
                                          name={`client_contact.${index}.mail_id`}
                                          placeholder="Email"
                                        />
                                        <ErrorMessage
                                          name={`client_contact.${index}.mail_id`}
                                          component="span"
                                        />
                                      </div>
                                    </div>
                                    <div className="d-flex list-headings">
                                      <p className="d-flex">Phone</p>
                                      <div className="drpdwn-slct">
                                        <Field
                                          name={`client_contact.${index}.phone_number`}
                                          placeholder="Phonenumber"
                                        />
                                        <ErrorMessage
                                          name={`client_contact.${index}.phone_number`}
                                          component="span"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                    </div>
                    <div className="modal-footer" style={{ zIndex: 1000 }}>
                      <div></div>
                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn cancel"
                          data-bs-dismiss="modal"
                          onClick={handleClientContactModelClose}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn save"
                          data-bs-dismiss="modal"
                          disabled={clientContactSaveBtnClicked || isSubmitting}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </FieldArray>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const OpenClientInChargeModel = ({
  showClientInChargeModel,
  handleClientInChargeModelClose,
  myToast,
  employeesList,
  refreshClientDetails,
  clientDetails,
  setSelectedEmployee,
  selectedEmployee,
  clientInChargeForm,
  isClientUpdate,
  setSelectedClientName,
}: {
  showClientInChargeModel: boolean;
  handleClientInChargeModelClose: () => void;
  myToast: any;
  employeesList: Employees[];
  refreshClientDetails: any;
  clientDetails: ClientList | undefined;
  setSelectedEmployee: React.Dispatch<React.SetStateAction<string>>;
  selectedEmployee: string;
  clientInChargeForm: ClientInChargeForm;
  isClientUpdate: boolean;
  setSelectedClientName: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
}) => {
  const [isInChargeBtnClicked, setIsInChargeBtnClicked] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const showToast = (
    severityValue: string,
    summaryValue: string,
    detailValue: string
  ) => {
    myToast.current.show({
      severity: severityValue,
      summary: summaryValue,
      detail: detailValue,
    });
  };

  const handleClientInChargeForm = async (values: ClientInChargeForm) => {
    try {
      if (values && clientDetails?._id) {
        const resp = await updateClientInCharge(
          clientDetails._id,
          values.client_incharge
        );
        if (resp.status === 200) {
          showToast(
            "success",
            "Success Message",
            "Client Contact Data was updated successfully."
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
    refreshClientDetails();
    handleClientInChargeModelClose();
    setIsInChargeBtnClicked(false);
  };

  const assgineesOptionTemplate = (option: any) => {
    return (
      <div className="d-flex sm-user-name">
        {/* {option.profilepic ? <img src={option.profilepic} /> : <img src={defaultpicture} />} */}
        <DefaultImage
          src={option.profilepic}
          alt=""
          className=""
          letter={option.name[0]}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const selectedAssgineesTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="d-flex sm-user-name">
          {/* {option.profilepic ? <img src={option.profilepic} /> : <img src={defaultpicture} />} */}
          <DefaultImage
            src={option.profilepic}
            alt=""
            className=""
            letter={option.name[0]}
          />
          <div>{option.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const getAssigneeFromList = (employee: string) =>
    employeesList
      ?.filter((assignee) => assignee._id === employee)
      .reduce(
        (preValue, currValue) => {
          const {
            name,
            profilepic_key,
            profilepic,
            email_id,
            phonenumber,
            _id,
          } = currValue;
          preValue.name = name;
          preValue.profilepic = profilepic;
          preValue.profilepic_key = profilepic_key || "";
          preValue._id = _id;
          preValue.email_id = email_id;
          preValue.phonenumber = phonenumber;
          return preValue;
        },
        {
          name: "",
          profilepic: "",
          _id: "",
          profilepic_key: "",
          phonenumber: "",
          email_id: "",
        }
      );

  const removeMatchedAssignees = (
    employeesList: Employees[],
    assignee: Employees
  ) => {
    employeesList.forEach((res, index) => {
      if (res._id == assignee._id) {
        employeesList.splice(index, 1); // remove element
      }
    });
    return employeesList;
  };
  const checkDeleted = (data: any) => {
    return data?.client_incharge?.length ? false : !isDeleted;
  };
  return (
    <Dialog
      visible={showClientInChargeModel}
      onHide={() => handleClientInChargeModelClose()}
      style={{ width: "40vw" }}
      header={"Select Client In Charge People"}
    >
      <Formik
        initialValues={clientInChargeForm}
        onSubmit={(values: any) => {
          setIsInChargeBtnClicked(true);
          handleClientInChargeForm(values);
        }}
      >
        {({ values }) => {
          return (
            <Form>
              <FieldArray name="client_incharge">
                {({ push, remove }) => (
                  <div>
                    <div className="modal-head">
                      <div className="dropdown-search-buttom-group d-flex">
                        <div className="drpdwn-slct drpdwn-input">
                          <Dropdown
                            name="employeesList"
                            optionLabel="name"
                            optionValue="_id"
                            value={selectedEmployee}
                            options={employeesList?.filter(
                              (assignee) => assignee._id !== selectedEmployee
                            )}
                            onChange={(e) => {
                              setSelectedEmployee(e.target.value);
                              const person = getAssigneeFromList(
                                e.target.value
                              );
                              values?.client_incharge?.filter(
                                (e: any) => e.email_id === person?.email_id
                              )?.length === 0 && push(person);
                            }}
                            itemTemplate={assgineesOptionTemplate}
                            valueTemplate={selectedAssgineesTemplate}
                            placeholder="Select"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="modal-body">
                      {values?.client_incharge?.length > 0 &&
                        values?.client_incharge?.map(
                          (item: any, index: any) => (
                            <div className="card-image-action-t-r" key={index}>
                              <button
                                className="d-flex outlined-button"
                                type="button"
                                data-bs-toggle="modal"
                                onClick={() => {
                                  remove(index);
                                  setIsDeleted(true);
                                }}
                                data-bs-target="#team-member-details"
                              >
                                <span className="material-icons-outlined">
                                  delete
                                </span>
                              </button>
                              <div className="card-image-block">
                                {/* <img src={item.profilepic && item.profilepic!= '' ? item.profilepic : defaultpicture} alt="lg-user-image" className="img-fluid" /> */}
                                <DefaultImage
                                  src={item.profilepic}
                                  alt="lg-user-image"
                                  className="img-fluid"
                                  letter={item.name[0]}
                                />
                              </div>
                              <div className="card-inner-details-block">
                                <h4>
                                  {" "}
                                  <Field
                                    name={`client_incharge.${index}.name`}
                                  />
                                </h4>
                                <div className="icon-text-group">
                                  <a href="javascript::">
                                    {" "}
                                    <span className="material-icons-round texted-icons">
                                      email
                                    </span>
                                    <Field
                                      name={`client_incharge.${index}.email_id`}
                                    />
                                  </a>
                                </div>
                                <div className="icon-text-group">
                                  <a href="javascript::">
                                    <span className="material-icons-round texted-icons">
                                      language
                                    </span>
                                    <Field
                                      name={`client_incharge.${index}.phonenumber`}
                                    />
                                  </a>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                    </div>
                    <div className="modal-footer" style={{ zIndex: 1000 }}>
                      <div></div>
                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn cancel"
                          data-bs-dismiss="modal"
                          onClick={handleClientInChargeModelClose}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className={
                            checkDeleted(values)
                              ? "btn btn-secondary "
                              : "btn save"
                          }
                          data-bs-dismiss="modal"
                          disabled={
                            isInChargeBtnClicked || checkDeleted(values)
                          }
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </FieldArray>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

const ProjectList = ({ clientDetails }: { clientDetails: ClientList }) => {
  const navigate = useNavigate();
  return (
    <div className="inr-split-two">
      <div className="card-ui card-head-body-group">
        <div className="card-head">
          <h3>
            {" "}
            Projects{" "}
            {clientDetails.projects?.length > 0
              ? `(${clientDetails.projects?.length})`
              : ""}{" "}
          </h3>
        </div>
        {clientDetails.projects && clientDetails.projects.length > 0 ? (
          clientDetails.projects.map((item: any, i: number) => (
            <div className="card-body" key={i}>
              <div className="card-image-action-t-r client-project-card">
                <button
                  className="d-flex outlined-button"
                  type="button"
                  onClick={() => {
                    navigate(`/task/${item._id}`);
                    // navigate(`/task`);
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#team-member-details"
                >
                  <span className="material-icons-outlined">arrow_forward</span>
                </button>
                <div className="card-inner-details-block">
                  <div className="user-img-details-last-updated d-flex">
                    <div className="user-image-block-sm">
                      <img
                        src={clientProjectCardImage}
                        alt="assig-5"
                        className="img-fluid"
                      />
                    </div>
                    <div className="user-name-last-update">
                      <h4> {item.project_name} </h4>
                      <h6 className="text-green"> {item.status} </h6>
                    </div>
                  </div>
                  <div className="user-img-details-last-updated d-flex">
                    <div className="user-image-block-sm">
                      <DefaultImage
                        src={item.leader_profilepic}
                        alt="assig-5"
                        className="img-fluid"
                        letter={item.leader.first_name[0]}
                      />
                    </div>
                    <div className="user-name-last-update">
                      {`${item.leader.first_name}` +
                        " " +
                        `${item.leader.last_name} (Leader)`}
                    </div>
                  </div>
                  <div className="user-img-details-last-updated d-flex">
                    <div className="user-image-block-sm">
                      <DefaultImage
                        src={item.manager_profilepic}
                        alt="assig-5"
                        className="img-fluid"
                        letter={item.manager.first_name[0]}
                      />
                    </div>
                    <div className="user-name-last-update">
                      {`${item.manager.first_name}` +
                        " " +
                        `${item.manager.last_name} (Manager)`}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="card-body">
            <div className="empty-middle-icon-text">
              <img src={projectEmptyIcon} className="img-fluid" />
              <p> No Projects Linked to this Client </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const ClientEditPanel = ({
  setIsClientUpdate,
  setSelectedImage,
  setshowClientModal,
  clientDetails,
  setClientFields,
  clientTypeList,
  permissions,
}: {
  setIsClientUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  clientDetails: ClientList;
  setSelectedImage: React.Dispatch<React.SetStateAction<string | undefined>>;
  setshowClientModal: React.Dispatch<React.SetStateAction<boolean>>;
  setClientFields: React.Dispatch<React.SetStateAction<ClientForm>>;
  clientTypeList: ClientType[] | undefined;
  permissions: any;
}) => {
  return (
    <div className="card-ui top-img-card-details">
      <div className="top-img-card">
        {/* {clientDetails.profilepic ? <img src={clientDetails.profilepic} /> : <img src={defaultpicture} />} */}
        <DefaultImage
          src={clientDetails.profilepic}
          letter={clientDetails.client_name[0]}
        />
      </div>
      {hasPermission(permissions, ["clients:write"]) && (
        <div className="top-img-card-rght-actions">
          <button
            className="d-flex outlined-button"
            type="button"
            data-bs-toggle="modal"
            onClick={() =>
              setUpdateClientModal({
                setIsClientUpdate,
                setSelectedImage,
                setshowClientModal,
                clientDetails,
                setClientFields,
              })
            }
            data-bs-target="#client-edit-popup"
          >
            <span className="material-icons-round"> edit</span>
            <p>Edit</p>
          </button>
        </div>
      )}
      <h3>{clientDetails?.client_name} </h3>
      <p className="label-red-text">
        {" "}
        {clientTypeList?.map((item, index) =>
          clientDetails.client_type === item._id ? (
            <option key={index} value={item._id}>
              {item.name}
            </option>
          ) : (
            ""
          )
        )}
      </p>
      <div className="icon-text-group">
        <a href={clientDetails?.website || "javascript::"} target="_blank">
          {" "}
          <span className="material-icons-outlined texted-icons">language</span>
          {clientDetails?.website}{" "}
        </a>
        <a href={"javascript::"} target="_blank">
          {" "}
          <span className="material-icons-outlined texted-icons">
            location_on
          </span>
          {clientDetails?.location}{" "}
        </a>
      </div>
    </div>
  );
};

function Client() {
  const [selectedClient, setSelectedClient] = useState<string | undefined>();
  const [selectedClientName, setSelectedClientName] = useState<string>();
  const [showClientModal, setClientShow] = useState(false);
  const [selectClientDetails, setSelectClientDetails] = useState<ClientList>();
  const [isClientUpdate, setIsClientUpdate] = useState(false);
  let clientForm: ClientForm = {
    _id: "",
    client_name: "",
    profilepic: "",
    client_type: "",
    website: "",
    location: "",
    client_contact: [],
    client_incharge: [],
  };

  const [clientFields, setClientFields] = useState(clientForm);

  const { clientsList, isLoading, clientListMutate } = useClientList();

  const myToast = useRef(null);
  const checkPreIndex: any = (client: any) => {
    return client?._id === localStorage.getItem("preSelectedClient") || null;
  };
  const getIndex = () => {
    let preSelectedClient = localStorage.getItem("preSelectedClient") || null;
    return (preSelectedClient ? clientsList?.findIndex(checkPreIndex) : 0) || 0;
  };
  useEffect(() => {
    if (clientsList) {
      setSelectedClient(clientsList[getIndex()]?._id);
      setSelectedClientName(clientsList[getIndex()]?.client_name);
      clientListMutate();
    }
  }, [clientsList]);

  const handleClientClose = () => setClientShow(false);
  const handleClientShow = () => setClientShow(true);

  const hiddenFileInput = useRef(null);

  const { clientTypeList } = useClientTypeList();

  const [selectImage, setSelectedImage] = useState<string | undefined>();

  const [selectFilePath, setSelectedFilePath] = useState<string | undefined>();

  const { clientsDetails, clientDetailsMutate } =
    useClientDetails(selectedClient);

  const [selectedTeam, setSelectedTeam] = useState<string>("All");

  const [selectedEmployee, setSelectedEmployee] = useState("");

  const [rolesData, setRolesData] = useState<string>("All");

  const { employeesList, isEmployeesLoading, employeeListMutate } =
    useEmployeeList(selectedTeam, rolesData);

  let clientInChargeForm: ClientInChargeForm = {
    client_incharge: [],
    profilepic: "",
    name: "",
    mail_id: "",
    phone_number: "",
  };

  let clientContactForm: ClientContactForm = {
    profilepic: "",
    name: "",
    role: "",
    mail_id: "",
    phone_number: "",
    client_contact: [],
  };

  const [clientContactFields, setClientContactFields] =
    useState(clientContactForm);

  const { projectDetailsByClient } = useProjectDetailsByClient(selectedClient);
  const [permissions, setPermissions] = useState<string[]>([]);

  useEffect(() => {
    _getPermissions();
    return () => {
      localStorage.removeItem("preSelectedClient");
    };
  }, []);

  const _getPermissions = async () => {
    let token = await getPermissionsList();
    setPermissions(token.permissions);
  };

  return (
    <>
      <ClientSidePanel
        clientsList={clientsList}
        isLoading={isLoading}
        setSelectedClient={setSelectedClient}
        selectedClientName={setSelectedClientName}
        clientId={selectedClient}
        setshowClientModal={setClientShow}
        setSelectClientDetails={setSelectClientDetails}
        setIsClientUpdate={setIsClientUpdate}
        setClientFields={setClientFields}
        clientMutate={clientListMutate}
        permissions={permissions}
      />

      <Toast ref={myToast} />
      <ClientModal
        myToast={myToast}
        isClientUpdate={isClientUpdate}
        showClientModal={showClientModal}
        handleClientClose={handleClientClose}
        clientFields={clientFields}
        refreshClientList={clientListMutate}
        clientTypeList={clientTypeList}
        setSelectedClient={setSelectedClient}
        setSelectedClientName={setSelectedClientName}
        hiddenFileInput={hiddenFileInput}
        setSelectedImage={setSelectedImage}
        setSelectedFilePath={setSelectedFilePath}
        selectImage={selectImage}
        selectFilePath={selectFilePath}
        clientDetailsMutate={clientDetailsMutate}
        handleClientShow={handleClientShow}
      />

      {clientsDetails ? (
        <ClientMainPage
          isClientUpdate={isClientUpdate}
          showClientModal={showClientModal}
          handleClientClose={handleClientClose}
          setshowClientModal={setClientShow}
          setIsClientUpdate={setIsClientUpdate}
          setClientFields={setClientFields}
          clientDetails={clientsDetails}
          employeesList={employeesList}
          setSelectedClient={setSelectedClient}
          setSelectedImage={setSelectedImage}
          setClientContactFields={setClientContactFields}
          clientContactFields={clientContactFields}
          refreshClientDetails={clientDetailsMutate}
          setSelectedEmployee={setSelectedEmployee}
          selectedEmployee={selectedEmployee}
          projectDetailsByClient={projectDetailsByClient}
          clientInChargeForm={clientInChargeForm}
          setSelectedClientName={setSelectedClientName}
          myToast={myToast}
          clientTypeList={clientTypeList}
          refreshClientList={clientListMutate}
          permissions={permissions}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Client;
